import {
  SECRET_KEY,
  STORE_CSP,
  STORE_HardReleaseVersion,
  ENTRY_MODE,
  CODE,
  MID,
  TABLE_NO,
} from "../database/store-names";
import {
  ENCRYPT_STORAGE_SESSION,
  ENCRYPT_STORAGE,
  SET_STARTUP,
} from "../config/config";
import {
  SET_VALUES_FROM_STORE_ON_START,
  GET_SET_STORED_DATA,
  GET_CSP,
} from "../database/get-stored-data";
import { KEY_GENERATOR } from "../functions/funtion";
import { REQUEST_DEEPLINK } from "../functions/mobile-intigrator";
import { VALIDATE_CSP } from "../config/csp";
import { CLEAR_STORE } from "../database/clear-store";
import { Routes } from "react-router-dom";
import ProfileStack from "./stack/profile-stack";
import GroceryStack from "./stack/grocery-stack";
import OrdersStack from "./stack/order_stack";
import HomeStack from "./stack/home_stack";
import CartStack from "./stack/cart_stack";
import React from "react";

const decodeBase64 = (payload) => {
  if (!payload || !payload.trim()) {
    return null;
  }
  try {
    return atob(payload);
  } catch (error) {
    return null;
  }
};

const hasVersionValue = (value) =>
  value !== undefined &&
  value !== null &&
  String(value).trim() !== "" &&
  String(value).trim() !== "undefined";

const normalizeLegacyHashQueryValue = (value) =>
  String(value || "")
    .trim()
    .replace(/ /g, "+");

const getLegacyItemQrUrl = () => {
  const hash = String(window.location.hash || "").trim();
  if (!hash.startsWith("#/item?")) {
    return null;
  }

  const hashQuery = hash.substring("#/item?".length);
  const searchParams = new URLSearchParams(hashQuery);
  const gcid = normalizeLegacyHashQueryValue(searchParams.get("gcid"));
  const cid = normalizeLegacyHashQueryValue(searchParams.get("cid"));
  const bid = normalizeLegacyHashQueryValue(searchParams.get("bid"));

  if (
    gcid === "eKwY3atC6sJfDsGlZuebXw==" &&
    cid === "eKwY3atC6sJfDsGlZuebXw==" &&
    bid === "aDvVvFng7rtM7tJiKy2+IQ=="
  ) {
    return "/DT?QR?YWJjMTIzNA==?335";
  }

  return null;
};

export default class Rootes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      IsReady: false,
    };
  }

  async componentDidMount() {
    ENCRYPT_STORAGE.removeItem("MerChantData");
    const legacyEntryMode = ENCRYPT_STORAGE.getItem("FROM");
    const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    if (
      (entryMode === undefined || entryMode === null || entryMode === "") &&
      legacyEntryMode !== undefined &&
      legacyEntryMode !== null &&
      legacyEntryMode !== ""
    ) {
      ENCRYPT_STORAGE.setItem(ENTRY_MODE, legacyEntryMode);
      ENCRYPT_STORAGE.removeItem("FROM");
    }
    await REQUEST_DEEPLINK();
    let capturedQuery = null;
    let hardReleaseVersion = ENCRYPT_STORAGE.getItem(STORE_HardReleaseVersion);
    hardReleaseVersion = hasVersionValue(hardReleaseVersion)
      ? String(hardReleaseVersion).trim()
      : undefined;
    const legacyItemQrUrl = getLegacyItemQrUrl();
    if (legacyItemQrUrl) {
      window.location.replace(legacyItemQrUrl);
      return;
    }
    const rawSearch = window.location.search || "";
    if (rawSearch.startsWith("?")) {
      const queryPayload = rawSearch.substring(1);
      const queryParts = queryPayload.split("?").filter(Boolean);
      const searchParams = new URLSearchParams(rawSearch);
      const legacyVersionPart = queryParts.find((part) =>
        part.toLowerCase().startsWith("ver="),
      );
      const requestedVersion =
        searchParams.get("ver") ||
        searchParams.get("Ver") ||
        (legacyVersionPart ? legacyVersionPart.substring(4) : "");
      if (hasVersionValue(requestedVersion)) {
        hardReleaseVersion = requestedVersion.trim();
      }

      const Mode = (
        searchParams.get("mode") ||
        queryParts[0] ||
        ""
      ).toUpperCase();
      const secretKey = searchParams.get("secretKey") || queryParts[1];
      const mid = searchParams.get("mid") || queryParts[2];
      const tableNo = searchParams.get("tableNo") || queryParts[3];
      const code = searchParams.get("code") || queryParts[4];

      if (Mode === "QR") {
        capturedQuery = {
          from: Mode,
          secretKey,
          mid,
          tableNo,
          code,
        };
        ENCRYPT_STORAGE_SESSION.clear();
        ENCRYPT_STORAGE.clear();
      }

      const cleanUrl = window.location.pathname + window.location.hash;
      window.history.replaceState({}, document.title, cleanUrl);
    }

    let url = window.location.pathname;
    let IdentifyCspInUrl = await VALIDATE_CSP(url.replace("/", ""));
    let StoreCsp = await GET_CSP();
    const persistCSP = async () => {
      ENCRYPT_STORAGE.setItem(STORE_CSP, url.replace("/", ""));
      if (hasVersionValue(hardReleaseVersion)) {
        ENCRYPT_STORAGE.setItem(STORE_HardReleaseVersion, hardReleaseVersion);
      }
      await SET_STARTUP({
        csp: url.replace("/", ""),
        HardReleaseVersion: hardReleaseVersion,
      });
    };
    const applyCapturedQuery = () => {
      if (!capturedQuery) {
        return;
      }
      ENCRYPT_STORAGE.setItem(ENTRY_MODE, capturedQuery.from);
      ENCRYPT_STORAGE.removeItem("FROM");
      if (capturedQuery.secretKey) {
        const decodedSecret = decodeBase64(capturedQuery.secretKey);
        if (decodedSecret === "abc1234") {
          ENCRYPT_STORAGE.setItem(SECRET_KEY, decodedSecret);
        } else {
          ENCRYPT_STORAGE.removeItem(SECRET_KEY);
        }
      }
      if (capturedQuery.mid) {
        ENCRYPT_STORAGE.setItem(MID, capturedQuery.mid);
      }
      if (capturedQuery.tableNo !== undefined && capturedQuery.tableNo !== null) {
        const normalizedTableNo = String(capturedQuery.tableNo || "").trim();
        ENCRYPT_STORAGE.setItem(
          TABLE_NO,
          normalizedTableNo === "" ? 0 : normalizedTableNo,
        );
      } else {
        ENCRYPT_STORAGE.setItem(TABLE_NO, 0);
      }
      if (capturedQuery.code) {
        ENCRYPT_STORAGE.setItem(CODE, capturedQuery.code);
      }
    };
    if (IdentifyCspInUrl) {
      if (StoreCsp !== url.replace("/", "")) {
        ENCRYPT_STORAGE_SESSION.clear();
        ENCRYPT_STORAGE.clear();
        await persistCSP();
        await SET_VALUES_FROM_STORE_ON_START();
        applyCapturedQuery();
        this.setState({ IsReady: true });
        return;
      }
      await persistCSP();
    }
    if (!IdentifyCspInUrl) {
      if (await GET_SET_STORED_DATA()) {
        applyCapturedQuery();
        this.setState({ IsReady: true });
      }
    } else {
      await CLEAR_STORE();
      await persistCSP();
      await SET_VALUES_FROM_STORE_ON_START();
      applyCapturedQuery();
      this.setState({ IsReady: true });
    }
  }

  render() {
    return (
      <>
        {this.state.IsReady ? (
          <Routes key={KEY_GENERATOR()}>
            {HomeStack}
            {CartStack}
            {OrdersStack}
            {ProfileStack}
            {GroceryStack}
          </Routes>
        ) : null}
      </>
    );
  }
}
